module.exports = __webpack_public_path__ + "img/news11-0.2472f79e.png";